var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form" }, [
      _c("div", { staticClass: "form-group" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value " },
          [
            _c(
              "el-select",
              {
                attrs: { "collapse-tags": "", placeholder: "请选择" },
                model: {
                  value: _vm.servcTypeId,
                  callback: function($$v) {
                    _vm.servcTypeId = $$v
                  },
                  expression: "servcTypeId"
                }
              },
              _vm._l(_vm.servcTypeEnumList, function(item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.text, value: item.value }
                })
              })
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("分类信息")]),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "swb-btn-link", on: { click: _vm.selectGoodsCat } },
        [_vm._v("选择")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "table",
              { staticClass: "custom-tbl", staticStyle: { width: "100%" } },
              [
                _vm._m(2),
                _vm._v(" "),
                _vm._l(_vm.goodsCatList, function(goodsCat, index) {
                  return _c("tbody", { staticClass: "body" }, [
                    _c("tr", { staticClass: "row" }, [
                      _c("td", [_vm._v(_vm._s(goodsCat.catName))]),
                      _vm._v(" "),
                      goodsCat.catId3 != null
                        ? _c("td", [_vm._v("三级")])
                        : goodsCat.catId2 != null
                        ? _c("td", [_vm._v("二级")])
                        : goodsCat.catId1 != null
                        ? _c("td", [_vm._v("一级")])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.removeGoodsCat(index)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      ])
                    ])
                  ])
                }),
                _vm._v(" "),
                _vm.goodsCatList == null || _vm.goodsCatList.length <= 0
                  ? _c("tfoot", { staticClass: "foot" }, [_vm._m(3)])
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-caption dashed required" }, [
      _c("span", [_vm._v("资质要求")]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "swb-btn-link",
          on: { click: _vm.selectStaffQualiType }
        },
        [_vm._v("选择")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "form-value" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "table",
              { staticClass: "custom-tbl", staticStyle: { width: "100%" } },
              [
                _vm._m(4),
                _vm._v(" "),
                _vm._l(_vm.staffQualiTypeList, function(staffQualiType, index) {
                  return _c("tbody", { staticClass: "body" }, [
                    _c("tr", { staticClass: "row" }, [
                      _c("td", [_vm._v(_vm._s(staffQualiType.name))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              on: {
                                change: function($event) {
                                  _vm.selectQualiType(staffQualiType)
                                }
                              },
                              model: {
                                value: staffQualiType.selectLevel,
                                callback: function($$v) {
                                  _vm.$set(staffQualiType, "selectLevel", $$v)
                                },
                                expression: "staffQualiType.selectLevel"
                              }
                            },
                            _vm._l(staffQualiType.levelList, function(level) {
                              return _c("el-option", {
                                attrs: { label: level.name, value: level.value }
                              })
                            })
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.requiredChange },
                              model: {
                                value: staffQualiType.required,
                                callback: function($$v) {
                                  _vm.$set(staffQualiType, "required", $$v)
                                },
                                expression: "staffQualiType.required"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("否")
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("是")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.removeStaffQualiType(index)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      ])
                    ])
                  ])
                }),
                _vm._v(" "),
                _vm.staffQualiTypeList == null ||
                _vm.staffQualiTypeList.length <= 0
                  ? _c("tfoot", { staticClass: "foot" }, [_vm._m(5)])
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(6),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form" }, [
      _c("div", { staticClass: "form-group" }, [
        _vm._m(7),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.memo,
                expression: "memo"
              }
            ],
            staticClass: "width-2x",
            attrs: { placeholder: "请输入" },
            domProps: { value: _vm.memo },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.memo = $event.target.value
              }
            }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("服务类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("服务类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", [_vm._v("分类")]),
        _vm._v(" "),
        _c("th", [_vm._v("分类级别")]),
        _vm._v(" "),
        _c("th", [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c("td", { attrs: { colspan: "3" } }, [
        _c("a", { staticClass: "font-gray" }, [_vm._v("暂无数据")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", [_vm._v("资质名称")]),
        _vm._v(" "),
        _c("th", [_vm._v("等级")]),
        _vm._v(" "),
        _c("th", [_vm._v("是否必需")]),
        _vm._v(" "),
        _c("th", [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c("td", { attrs: { colspan: "4" } }, [
        _c("a", { staticClass: "font-gray" }, [_vm._v("暂无数据")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("其他信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("备注")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e106d74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e106d74","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/quali/StaffQualiClaimToDevcSave.vue
// module id = 1907
// module chunks = 1